import { motion } from "framer-motion";
import { Camera, Check, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FilmedVideo } from "@/components/home/FilmedSetsSection";

export const FilmedUpsell = ({ onUpgrade }) => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    className="relative overflow-hidden rounded-2xl border border-fuchsia-500/40 bg-gradient-to-br from-fuchsia-500/15 via-dream-surface to-dream-violet/15 p-5 mb-6 flex gap-5 items-center"
    data-testid="filmed-upsell"
  >
    <div className="w-20 sm:w-24 aspect-[9/16] rounded-xl overflow-hidden flex-shrink-0 border border-white/15">
      <FilmedVideo testId="filmed-upsell-video" />
    </div>
    <div className="flex-1 min-w-0">
      <p className="text-fuchsia-300 text-xs font-mono uppercase tracking-widest flex items-center gap-1.5"><Sparkles className="w-3.5 h-3.5" /> Upgrade your session</p>
      <h3 className="font-heading text-lg sm:text-xl font-bold text-white mt-1">Get your set filmed for +$65</h3>
      <p className="text-white/60 text-sm mt-1">Same date &amp; time. Shot on Nikon Z5 + GoPro, full set audio recorded, raw clips for your socials. Total $125.</p>
      <Button onClick={onUpgrade} className="mt-3 bg-gradient-to-r from-fuchsia-500 to-dream-violet hover:opacity-90 text-white rounded-full px-5 font-semibold" data-testid="filmed-upsell-btn">
        <Camera className="w-4 h-4 mr-2" /> Yes, film my set (+$65)
      </Button>
    </div>
  </motion.div>
);

export const FilmedUpgradedNote = ({ onRevert }) => (
  <div className="rounded-2xl border border-green-500/40 bg-green-500/10 p-4 mb-6 flex flex-wrap items-center justify-between gap-3" data-testid="filmed-upgraded-note">
    <p className="text-green-300 text-sm font-semibold flex items-center gap-2"><Check className="w-4 h-4" /> Upgraded: your set will be filmed</p>
    <button onClick={onRevert} className="text-white/60 hover:text-white text-xs underline underline-offset-4" data-testid="filmed-upsell-revert-btn">
      Switch back to the $60 package
    </button>
  </div>
);
